import React from 'react';
import { Container, Typography, Paper, Divider } from '@mui/material';

const About = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        About
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Information about the Admin Dashboard
      </Typography>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Admin Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Admin dashboard application for monitoring NorthStar Fuel user logs from MongoDB database.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" gutterBottom>
          Version
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          1.0.0
        </Typography>

        <Typography variant="subtitle2" gutterBottom>
          Features
        </Typography>
        <Typography variant="body2" color="text.secondary" component="div">
          <ul>
            <li>Real-time log monitoring</li>
            <li>Advanced filtering and search</li>
            <li>Log statistics and analytics</li>
            <li>MongoDB connection monitoring</li>
          </ul>
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" gutterBottom>
          Database
        </Typography>
        <Typography variant="body2" color="text.secondary">
          MongoDB: nsf_logs.app_logs
        </Typography>
      </Paper>
    </Container>
  );
};

export default About;

